import React from 'react';
import SegmentGraph from '@di-shared/features/home/kr/ev-battery/SegmentGraph';
import EVAverageGraph from '@di-shared/features/home/kr/ev-battery/EVAverageGraph';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {GetEvBatteryManagementChargeResponse} from '@di-shared/api/di/__generated';
import batteryLevelStatus = GetEvBatteryManagementChargeResponse.batteryLevelStatus;

interface BatteryLevelManagerProps {
  user: BatteryLevel;
  avgCustomer: BatteryLevel;
  batteryLevelStatus: batteryLevelStatus;
}

interface BatteryLevel {
  start: number;
  end: number;
}

function getDescKey(batteryLevel: batteryLevelStatus) {
  switch (batteryLevel) {
    case batteryLevelStatus.LOW:
      return 'T30426';
    case batteryLevelStatus.MEDIUM:
      return 'T30427';
    case batteryLevelStatus.HIGH:
      return 'T30428';
    case batteryLevelStatus.DEFAULT:
    default:
      return 'T30425';
  }
}

function BatteryLevelManager({user, avgCustomer, batteryLevelStatus}: BatteryLevelManagerProps) {
  const {t} = useInferableTranslation();
  return (
    <EVAverageGraph
      title={t('T30421')}
      desc={t(getDescKey(batteryLevelStatus))}
    >
      <SegmentGraph
        user={user}
        avgCustomer={avgCustomer}
      />
    </EVAverageGraph>
  );
}

export default BatteryLevelManager;
